import React from "react";
import { Text, Stack, Flex, Box } from "@chakra-ui/react";
import { textSecondary, textPrimary, color2 } from "../../../utils/colors";

export const columnsDesktop = (translate, currencySymbol) => {
  return [
    {
      Header: translate("service.service"),
      accessor: "serviceName",
      Cell: ({ row }) => {
        const { service, teeth, order, reimbursement } = row.original;
        // console.log("row.original", row.original);

        const reimbursedAmount =
          reimbursement && reimbursement.reimbursedAmount
            ? reimbursement.reimbursedAmount
            : 0;

        return (
          <Flex align="flex-start">
            <Text
              minWidth="17px"
              overflow="hidden"
              whiteSpace="nowrap"
              fontSize="xs"
              fontWeight="500"
              color={textSecondary}
              mr={1}
            >
              {order}.
            </Text>
            <Flex align="center">
              <Stack gap={0}>
                <Text
                  fontSize="0.8rem"
                  color={textPrimary}
                  fontWeight="500"
                  isTruncated // This will add ellipsis
                  maxW="280px"
                >
                  {(service && service.name && service.name) || "-"}
                </Text>
                {/* {teeth && teeth.length > 0 && (
                  <Flex maxW="280px">
                    <Text fontSize="xs" color={textSecondary} fontWeight="500">
                      {teeth && teeth.length > 0 ? teeth.join(", ") : "-"}
                    </Text>
                  </Flex>
                )} */}

                <Flex maxW="280px">
                  {teeth && teeth.length > 0 && (
                    <Text
                      fontSize="xs"
                      color={textSecondary}
                      fontWeight="500"
                      mr={2}
                    >
                      {translate("service.toothArea")}:{" "}
                      <Text
                        as="span"
                        fontSize="xs"
                        color={textSecondary}
                        fontWeight="500"
                      >
                        {teeth && teeth.length > 0 ? teeth.join(", ") : "-"}
                      </Text>
                    </Text>
                  )}

                  {reimbursedAmount > 0 && (
                    <Text fontSize="xs" color={textSecondary} fontWeight="500">
                      {translate("service.reimbursedAmount")}:
                      <Text
                        as="span"
                        fontSize="xs"
                        color={textPrimary}
                        fontWeight="500"
                        ml={1}
                      >
                        <Text as="span" color={color2} mr={1}>
                          {currencySymbol}
                          {reimbursedAmount}
                        </Text>
                      </Text>
                    </Text>
                  )}
                </Flex>
              </Stack>
            </Flex>
          </Flex>
        );
      },
    },

    {
      Header: translate("service.quantity"),
      accessor: "quantity",
      Cell: ({ row }) => {
        const { quantity } = row.original;

        return (
          <Text
            fontSize="xs"
            color={textSecondary}
            fontWeight="500"
            isTruncated // This will add ellipsis
            noOfLines={1} // This will limit the text to two lines
            whiteSpace="nowrap"
            overflow="hidden"
          >
            {quantity}
            <Text as="span" color={textSecondary} ml={1}>
              {translate("common.qty")}
            </Text>
          </Text>
        );
      },
    },
    {
      Header: translate("form.price"),
      accessor: "price",
      // width: 100,
      Cell: ({ row }) => {
        const { price, discountValue, discountedPrice } = row.original;

        return (
          <>
            <Box>
              {discountValue > 0 ? (
                <Flex align="center">
                  <Text
                    fontSize="xs"
                    color={textSecondary}
                    fontWeight="500"
                    whiteSpace="nowrap"
                    mr={2}
                  >
                    {currencySymbol} {discountedPrice}
                  </Text>

                  <Text
                    fontSize="xs"
                    color={textSecondary}
                    opacity="0.6"
                    fontWeight="500"
                    whiteSpace="nowrap"
                    textDecoration="line-through"
                  >
                    {currencySymbol} {price}
                  </Text>
                </Flex>
              ) : (
                <Text
                  fontSize="xs"
                  color={textSecondary}
                  fontWeight="500"
                  whiteSpace="nowrap"
                  w="100%"
                >
                  {currencySymbol} {price}
                </Text>
              )}
            </Box>
          </>
        );
      },
    },
    {
      Header: () => (
        <Text w="100%" textAlign="right">
          {translate("common.total")}
        </Text>
      ),
      accessor: "total",
      // width: 50,
      Cell: ({ row }) => {
        const { totalPrice, reimbursement } = row.original;

        // const reimbursedAmount =
        //   reimbursement && reimbursement.reimbursedAmount
        //     ? reimbursement.reimbursedAmount
        //     : 0;

        return (
          <>
            <Text
              fontSize="xs"
              color={textPrimary}
              fontWeight="500"
              textAlign="right" // ← Add this line
            >
              {currencySymbol} {totalPrice}
            </Text>

            {/* {reimbursedAmount > 0 ? (
              <Text
                fontSize="xs"
                color={textPrimary}
                fontWeight="500"
                textAlign="right" // ← Add this line
              >
                <Text as="span" color={color2} mr={1}>
                  ({reimbursedAmount} {currencySymbol})
                </Text>
                {totalPrice} {currencySymbol}
              </Text>
            ) : (
              <Text
                fontSize="xs"
                color={textPrimary}
                fontWeight="500"
                textAlign="right" // ← Add this line
              >
                {totalPrice} {currencySymbol}
              </Text>
            )} */}
          </>
        );
      },
    },
  ];
};
